var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['campaign-background', { 'is-moved': _vm.isMoved }]})}
var staticRenderFns = []

export { render, staticRenderFns }